<template>
  <div id="radar-grid-layer">
    <!-- <rg-last-object-tracking :start-time="lastObjectTracking.startTime"
                             :track-no="lastObjectTracking.trackNo"></rg-last-object-tracking> -->
  </div>
</template>

<script>
import Vue from "vue";
import { db } from "@/firebase/firebaseConfig.js";
import * as turfHelpers from "@turf/helpers";
// import RgPopup from "./components/RgPopup.vue";
// import RgCamera from "./components/RgCamera.vue";
// import RgLastObjectTracking from "./components/RgLastObjectTracking.vue";
import { RadarGridMixin } from "@/mixins";
import moment from "moment-timezone";
import AuthService from "@/services/authService";

export default {
  name: "RadarGridLayer",
  mixins: [RadarGridMixin],
  // components: {RgLastObjectTracking},
  data() {
    return {
      initialized: false,
      layersMinZoom: 5,
      radarGridSourceId: "RadarGridSourceId",
      radarGridMapLayerId: "RadarGridMapLayerId",
      radarGridFrameLayerId: "radarGridFrameLayerId",
      radarGridInfo: new Map(),
      radarGridObjectFeatures: [],
      radarGridObjectPopupIds: [],
      popupViewInstances: new Map(),
      cameraViewInstances: new Map(),
      showLastObjectTracking: false,
      unsubscribeList: [],
      lastObjectTracking: {
        trackNo: null,
        startTime: null,
        momentObj: null,
      },
      uuid: null,
      cameraIds: [],
      cameraCtlPermissions: new Map(),
      targetIcon: null,
      objectIdsToBeShowFrame: [],
      timeoutIdsOfShowFrame: {},
    };
  },
  props: {
    map: Object,
    isReady: { type: Boolean, default: false },
    mapEvent: String,
  },
  watch: {
    mapEvent() {},
    async isReady() {
      if (this.isReady) {
        await this.addMapSources();
        await this.addMapLayers();
        this.filterFrameById(this.showFrameObjectFilter);
        if (!this.initialized) {
          await this.addClickEvent();
          await this.subscribeRadarGridObjects();
          this.initialized = true;
        }

        this.addBlinkIcons();
        this.addFrameIcons();
      }
    },

    showFrameObjectFilter() {
      this.filterFrameById(this.showFrameObjectFilter);
    },
  },
  computed: {
    showFrameObjectFilter() {
      return ["in", "id"].concat(this.objectIdsToBeShowFrame);
    },
  },

  methods: {
    async addMapSources() {
      this.map.addSource(this.radarGridSourceId, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: this.radarGridObjectFeatures || [],
        },
      });
    },
    async addMapLayers() {
      this.map.addLayer({
        id: this.radarGridMapLayerId,
        type: "symbol",
        minzoom: this.layersMinZoom,
        source: this.radarGridSourceId,
        layout: {
          "icon-allow-overlap": true,
          "icon-ignore-placement": true,
          "icon-image": "{objectIcon}",
          "text-justify": "right",
          "icon-rotate": {
            type: "identity",
            property: "cog",
          },
          "text-field": "{trackNumberN}",
          "text-size": 14,
          "text-offset": [-3, 0],
          "text-optional": true,
        },
        paint: {
          "text-color": {
            type: "identity",
            property: "textColor",
          },
        },
      });

      this.map.addLayer({
        id: this.radarGridFrameLayerId,
        type: "symbol",
        minzoom: this.layersMinZoom,
        source: this.radarGridSourceId,
        filter: ["all", ["!=", ["string", ["get", "frameIcon"], ""], ""]],
        layout: {
          "icon-image": "{frameIcon}",
          "icon-allow-overlap": true,
          "icon-ignore-placement": true,
        },
      });
    },

    async addClickEvent() {
      this.map.on("click", this.radarGridMapLayerId, (e) => {
        let properties = e.features[0].properties;
        if (this.popupViewInstances.has(properties.id)) {
          this.removePopup(properties.id);
          return;
        }
        if (properties.isAnalyzed) {
          let points = { x: `${e.point.x}px`, y: `${e.point.y}px` };
          let coordinates = [
            parseFloat(properties.log),
            parseFloat(properties.lat),
          ];
          this.appendPopupView(properties, coordinates, points);
        }
      });

      this.map.on("mouseenter", this.radarGridMapLayerId, () => {
        this.map.getCanvas().style.cursor = "pointer";
      });

      this.map.on("mouseleave", this.radarGridMapLayerId, () => {
        this.map.getCanvas().style.cursor = "";
      });
    },

    appendPopupView(properties, coordinates, points) {
      let ComponentClass = Vue.extend(RgPopup);
      let instance = new ComponentClass({
        propsData: {
          objectId: properties.id,
          elId: `rg-popup-${properties.id}`,
          points: points,
        },
      });
      instance.$on("onClickTrackBtn", (coordinates) => {
        this.map.flyTo({ center: coordinates, zoom: 13 });
      });
      instance.$on("onClickCloseBtn", (objectId) => {
        this.removePopup(objectId);
      });
      instance.$on("onClickVideoBtn", (objectId, trackNumber, cameraId) => {
        if (this.cameraViewInstances.size !== 0) {
          this.cameraViewInstances.forEach((value, key) => {
            if (key === cameraId) {
              this.removeCamera(key);
            }
          });
        }
        this.appendCameraView(objectId, trackNumber, cameraId);
      });
      instance.setData(properties);
      instance.$mount();
      document.getElementById("radar-grid-layer").append(instance.$el);
      this.popupViewInstances.set(properties.id, instance);
    },

    updatePopupView(properties, isDelete) {
      if (this.popupViewInstances.has(properties.id)) {
        let instance = this.popupViewInstances.get(properties.id);
        if (!isDelete) {
          instance.setData(properties);
        } else {
          instance.setError("このオブジェクトは監視対象から外れました");
        }
      }
    },

    removePopup(popupId) {
      let instance = this.popupViewInstances.get(popupId);
      instance.$destroy();
      instance.$el.parentNode.removeChild(instance.$el);
      this.popupViewInstances.delete(popupId);
    },

    async appendCameraView(objectId, trackNumber, cameraId) {
      let ComponentClass = Vue.extend(RgCamera);
      let rgInfo = this.radarGridInfo.get(objectId);
      let elId = "rg-camera-" + objectId;
      let instance = new ComponentClass({
        propsData: {
          elId: elId,
          cameraId: cameraId,
          trackNumber: trackNumber,
          uuid: this.uuid,
          rgInfo: rgInfo,
        },
      });
      instance.$on("onClickCloseBtn", (cameraId) => {
        this.removeCamera(cameraId);
      });
      instance.$mount();
      let status = this.hasCameraCtl(cameraId);
      instance.setCameraCtlSwitchStatus(status, false);
      document.getElementById("radar-grid-layer").append(instance.$el);
      this.cameraViewInstances.set(cameraId, instance);
    },

    hasCameraCtl(cameraId) {
      let cameraCtl = this.cameraCtlPermissions[cameraId];
      if (cameraCtl.p === null) return this.CAMERA_CTL_STATUS.AUTO;
      let timeDiff = moment()
        .utc()
        .diff(moment(cameraCtl.to.toDate()), "minute");
      if (cameraCtl.p === this.uuid && timeDiff === 0)
        return this.CAMERA_CTL_STATUS.MANUAL;
      if (timeDiff >= 1) return this.CAMERA_CTL_STATUS.AUTO;

      return this.CAMERA_CTL_STATUS.DISABLED;
    },

    removeCamera(cameraId) {
      let instance = this.cameraViewInstances.get(cameraId);
      instance.$destroy();
      instance.$el.parentNode.removeChild(instance.$el);
      this.cameraViewInstances.delete(cameraId);
    },

    async subscribeRadarGridObjects() {
      let subscribe = db
        .collection(this.RG_FB_COLLECTIONS.RADAR_GRID_OBJECTS)
        .onSnapshot((querySnapshot) => {
          querySnapshot.docChanges().forEach((change) => {
            let firestoreData = JSON.parse(JSON.stringify(change.doc.data()));
            let properties = this.crateProperties(firestoreData);
            let feature = turfHelpers.point(
              [properties.log, properties.lat],
              properties,
            );
            this.updateRadarGridObject(firestoreData, feature, change.type);
          });
        });

      this.unsubscribeList.push(subscribe);
    },

    async getCameraIds() {
      db.collection(this.RG_FB_COLLECTIONS.AI_CAMERA_CONTROL)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.cameraIds.push(doc.id);
            this.subscribeCameraCtl(doc.id);
          });
        });
    },

    async subscribeCameraCtl(cameraId) {
      let subscribe = db
        .collection(this.RG_FB_COLLECTIONS.AI_CAMERA_CONTROL)
        .doc(cameraId)
        .onSnapshot((doc) => {
          this.cameraCtlPermissions[doc.id] = doc.data();
          if (this.cameraViewInstances.size !== 0) {
            this.cameraViewInstances.forEach((value, _) => {
              if (cameraId === value.cameraId) {
                let status = this.hasCameraCtl(cameraId);
                value.setCameraCtlSwitchStatus(status);
              }
            });
          }
        });

      this.unsubscribeList.push(subscribe);
    },

    async unsubscribeFireStore() {
      if (this.unsubscribeList !== null && this.unsubscribeList.length > 0) {
        this.unsubscribeList.forEach((value) => {
          value();
        });
        this.unsubscribeList = [];
      }
    },

    updateRadarGridObject(firestoreData, feature, changeType) {
      if (changeType === "added") {
        this.radarGridObjectFeatures.push(feature);
        this.radarGridInfo.set(firestoreData.id, firestoreData.rg);
        this.blinkIcon(feature.properties);
      } else if (changeType === "modified") {
        let res = this.getRadarGridObjectFeatureIndex(feature);
        this.radarGridObjectFeatures.splice(res.index, 1);
        this.radarGridObjectFeatures.push(feature);
        if (res.hasChangedRiskLevel) {
          this.turnOffBlinkIcon(firestoreData.id);
          this.blinkIcon(feature.properties);
        }
        this.updatePopupView(feature.properties, false);
      } else {
        let res = this.getRadarGridObjectFeatureIndex(feature);
        this.radarGridObjectFeatures.splice(res.index, 1);
        this.updatePopupView(feature.properties, true);
        this.radarGridInfo.delete(firestoreData.id);
        this.objectIdsToBeShowFrame = this.objectIdsToBeShowFrame.filter(
          (id) => id !== firestoreData.id,
        );
      }

      this.map.getSource(this.radarGridSourceId).setData({
        type: "FeatureCollection",
        features: this.radarGridObjectFeatures,
      });
    },

    getRadarGridObjectFeatureIndex(feature) {
      let index = null;
      let hasChangedRiskLevel = false;
      for (const [i, val] of Object.entries(this.radarGridObjectFeatures)) {
        if (val.properties.id === feature.properties.id) {
          index = i;
          hasChangedRiskLevel =
            val.properties.riskLevel !== feature.properties.riskLevel;
          break;
        }
      }
      return {
        index: index,
        hasChangedRiskLevel: hasChangedRiskLevel,
      };
    },

    crateProperties(firestoreData) {
      let properties = {};
      const rgRiskLevelManager = this.createRgRiskLevelManager(firestoreData);
      const riskLevelObject =
        this.RADAR_GRID_OBJECT_RISK_LEVEL[rgRiskLevelManager.riskLevel];
      properties.textColor = riskLevelObject.color;
      properties.log = parseFloat(firestoreData.c.longitude);
      properties.lat = parseFloat(firestoreData.c.latitude);
      properties.sog = firestoreData.sog;
      properties.cog = firestoreData.cog;
      properties.objectIcon = rgRiskLevelManager.objectIcon;
      properties.trackNumber = `${firestoreData.n}`;
      properties.trackNumberN = this.isTracked(firestoreData.k)
        ? `Track\n${firestoreData.n}`
        : `Target\n${firestoreData.n}`;
      properties.k = firestoreData.k;
      properties.id = firestoreData.id;
      properties.frameIcon = rgRiskLevelManager.frameIconId;
      properties.riskLevel = rgRiskLevelManager.riskLevel;
      properties.man_r = firestoreData.man_r;
      properties.ai_r = firestoreData.ai_r;
      if (firestoreData.p.length !== 0) {
        properties.isAnalyzed = true;
        properties.cameraId = firestoreData.p[0].ci;
        properties.confidence = firestoreData.p[0].co
          ? `${Math.floor(firestoreData.p[0].co * 100)}`
          : "---";
        properties.imgUrl = firestoreData.p[0].p;
        properties.shootingDate = firestoreData.p[0].t
          ? this.toJST(firestoreData.p[0].t.seconds, `${firestoreData.n}`)
          : "---";
      } else {
        properties.isAnalyzed = false;
      }
      return properties;
    },

    addBlinkIcons() {
      this.map.addImage(
        this.getBrinkIconId(this.RG_RISK_LEVEL.CAUTION),
        this.getBrinkIcon(this.RG_RISK_LEVEL.CAUTION),
        { pixelRatio: 2 },
      );
      this.map.addImage(
        this.getBrinkIconId(this.RG_RISK_LEVEL.DANGER),
        this.getBrinkIcon(this.RG_RISK_LEVEL.DANGER),
        { pixelRatio: 2 },
      );
      this.map.addImage(
        this.getBrinkIconId(this.RG_RISK_LEVEL.SAFE),
        this.getBrinkIcon(this.RG_RISK_LEVEL.SAFE),
        { pixelRatio: 2 },
      );

      this.map.addImage(
        this.getBrinkIconId(this.RG_RISK_LEVEL.CAUTION, false),
        this.getBrinkIconOfOtherKind(this.RG_RISK_LEVEL.CAUTION),
        { pixelRatio: 2 },
      );
      this.map.addImage(
        this.getBrinkIconId(this.RG_RISK_LEVEL.DANGER, false),
        this.getBrinkIconOfOtherKind(this.RG_RISK_LEVEL.DANGER),
        { pixelRatio: 2 },
      );
      this.map.addImage(
        this.getBrinkIconId(this.RG_RISK_LEVEL.SAFE, false),
        this.getBrinkIconOfOtherKind(this.RG_RISK_LEVEL.SAFE),
        { pixelRatio: 2 },
      );
    },

    addFrameIcons() {
      this.map.addImage(
        this.getFrameIconId(this.RG_RISK_LEVEL.CAUTION),
        this.getFrameIcon(this.RG_RISK_LEVEL.CAUTION),
        { pixelRatio: 2 },
      );
      this.map.addImage(
        this.getFrameIconId(this.RG_RISK_LEVEL.DANGER),
        this.getFrameIcon(this.RG_RISK_LEVEL.DANGER),
        { pixelRatio: 2 },
      );
      this.map.addImage(
        this.getFrameIconId(this.RG_RISK_LEVEL.SAFE),
        this.getFrameIcon(this.RG_RISK_LEVEL.SAFE),
        { pixelRatio: 2 },
      );
    },

    async blinkIcon(props) {
      let coordinates = [props.log, props.lat];
      let blinkIconSourceId = props.id;

      this.turnOffBlinkIcon(blinkIconSourceId);
      this.map.addSource(blinkIconSourceId, {
        type: "geojson",
        data: {
          type: "FeatureCollection",
          features: [
            {
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: coordinates,
              },
            },
          ],
        },
      });

      let blinkIconLayerId = props.id;
      this.map.addLayer({
        id: blinkIconLayerId,
        type: "symbol",
        source: blinkIconSourceId,
        layout: {
          "icon-image": this.createRgRiskLevelManager(props).brinkIconId,
          "icon-allow-overlap": true,
          "icon-ignore-placement": true,
        },
      });

      this.$set(
        this.timeoutIdsOfShowFrame,
        blinkIconSourceId,
        window.setTimeout(() => {
          this.turnOffBlinkIcon(blinkIconSourceId);
          this.objectIdsToBeShowFrame.push(blinkIconSourceId);
          this.$delete(this.timeoutIdsOfShowFrame, blinkIconSourceId);
        }, 5000),
      );
    },

    turnOffBlinkIcon(blinkIconSourceId) {
      if (this.map.getLayer(blinkIconSourceId)) {
        this.map.removeLayer(blinkIconSourceId);
      }
      if (this.map.getSource(blinkIconSourceId)) {
        this.map.removeSource(blinkIconSourceId);
      }

      this.objectIdsToBeShowFrame = this.objectIdsToBeShowFrame.filter(
        (id) => id !== blinkIconSourceId,
      );
      const timeoutId = this.timeoutIdsOfShowFrame[blinkIconSourceId];
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    },

    toJST(unix, trackNumber) {
      let momentObjJst = moment(unix, "X").tz("Asia/Tokyo");
      this.setLastObjectTracking(momentObjJst, trackNumber);
      return momentObjJst.format("YYYY/MM/DD/ HH:mm");
    },

    setLastObjectTracking(momentObj, trackNumber) {
      if (this.lastObjectTracking.trackNo) {
        if (momentObj.isAfter(this.lastObjectTracking.momentObj)) {
          this.lastObjectTracking.trackNo = trackNumber;
          this.lastObjectTracking.startTime =
            momentObj.format("YYYY/MM/DD/ HH:mm");
          this.lastObjectTracking.momentObj = momentObj;
        }
      } else {
        this.lastObjectTracking.trackNo = trackNumber;
        this.lastObjectTracking.startTime =
          momentObj.format("YYYY/MM/DD/ HH:mm");
        this.lastObjectTracking.momentObj = momentObj;
      }
    },

    filterFrameById(filters) {
      if (!this.map) return;
      if (this.map.getLayer(this.radarGridFrameLayerId)) {
        this.map.setFilter(this.radarGridFrameLayerId, ["all", filters]);
      }
    },
  },

  async created() {
    let user = await AuthService.getUser();
    this.uuid = `${user.id}-${user.account_id}`;
    await this.getCameraIds();
  },

  beforeDestroy() {
    this.unsubscribeFireStore();
  },
};
</script>

<style lang="scss">
#radar-grid-layer {
  width: 100%;
}
</style>
